import { toRaw } from 'vue';

type Writeable<T> = { -readonly [P in keyof T]: T[P] };

export function cloneDeep<T>(input: T): Writeable<T> {
  return structuredClone(toRaw(input)) as Writeable<T>;
}
